import {Text, Tooltip} from "@blueprintjs/core";
import styled from "@emotion/styled";
import {ManifestStop, Maybe} from "../../../../generated/graphql";
import {activeStops} from "../../../../utils/stops/StopUtils";
import {isHasUnsupportedStatus, isSmallCard} from "../../../../utils/General";
import {IndicatorColors} from "../../../settings/ColorSettings/ColorizedIndicators/ColorizedIndicators";
import {UserColor} from "../../../settings/ColorSettings/ColorizedIndicators/types/indicatorLogicType";
import {WarningIcon} from "./cards/common/icons/StatusIconV3";
import {CardType} from "../../card-configuration/common/constants/enums";
import {CardTypeV2} from "../../card-configuration/v2/constants/enums";
type StopCountIndicatorProps = {
  stops: Maybe<ManifestStop[]> | undefined;
  fontSize?: string;
  indicatorColor?: string;
  cardType?: CardType | CardTypeV2;
};

const getFontSize = (numberOfStops: number, cardType: CardType | CardTypeV2 | undefined) => {
  return isSmallCard(cardType) && numberOfStops.toString().length >= 3 ? 8 : 12;
};

const StopCountIndicator = ({stops, indicatorColor, cardType}: StopCountIndicatorProps) => {
  const activeStopsCount = activeStops(stops);
  const isShowWarningIcon = isHasUnsupportedStatus(stops);
  const totalStops = stops?.length ?? 0;

  const stopCountWidth = cardType ? (isSmallCard(cardType) ? 19 : 27) : 32;
  const stopCountHeight = cardType ? (isSmallCard(cardType) ? 16 : 20) : 24;

  return (
    <NewStopCountIndicatorContainer data-testid="new-stop-count-indicator">
      <StopCount
        backgroundColor={indicatorColor ? IndicatorColors[indicatorColor as UserColor].hex : ""}
        width={stopCountWidth}
        height={stopCountHeight}
        fontSize={getFontSize(activeStopsCount, cardType)}
      >
        {isShowWarningIcon ? (
          <Tooltip
            content={
              <>
                <Text>The stop statuses of Queued, Accepted, and Cleared are supported on Dispatch.</Text>
                <Text>
                  Please navigate to Utility - Job Stop Status to make sure this stop type matches one of those 3
                  statuses.
                </Text>
              </>
            }
            popoverClassName="manifest-warning-popover"
            position="bottom"
          >
            <WarningIcon color={indicatorColor ? "#ffffff" : "#161616"} size={12} />
          </Tooltip>
        ) : (
          activeStopsCount
        )}
      </StopCount>
      <StopCount
        backgroundColor={indicatorColor ? IndicatorColors[indicatorColor as UserColor].hex : ""}
        width={stopCountWidth}
        height={stopCountHeight}
        fontSize={getFontSize(totalStops, cardType)}
      >
        {totalStops}
      </StopCount>
    </NewStopCountIndicatorContainer>
  );
};

export default StopCountIndicator;

const NewStopCountIndicatorContainer = styled.div`
  border-radius: 4px;
  height: fit-content;
  overflow: hidden;
  font-size: 12px;
  display: flex;
  gap: 2px;
`;
interface StopsCountProps {
  backgroundColor?: string;
  width: number;
  height: number;
  fontSize: number;
}

const StopCount = styled.div<StopsCountProps>`
  width: ${(props) => props.width && `${props.width}px`};
  height: ${(props) => props.height && `${props.height}px`};
  color: ${(props) => (props.backgroundColor ? "white" : "black")};
  background-color: ${(props) => props.backgroundColor || "#E0E0E0"};
  text-align: center;
  font-size: ${(props) => `${props.fontSize}px`};
  line-height: ${(props) => `${props.height}px`};
  font-weight: 500;
  .bp5-popover-target {
    padding-bottom: 2px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
